import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useMobile } from "@/components/ActionSheet";
import { useAuth } from "@/context/AuthContext";

// Aberto/fechado de uma secção; no computador lembra a escolha feita à mão (por pessoa, neste navegador).
export function useFoldState(key, initial) {
  const { user } = useAuth();
  const mobile = useMobile();
  const k = key && user?.id && !mobile ? `imodesk_fold_${user.id}_${key}` : null;
  const saved = k ? localStorage.getItem(k) : null;
  const [open, setRaw] = useState(saved != null ? saved === "1" : initial);
  const setOpen = (v) => { setRaw(v); if (k) localStorage.setItem(k, v ? "1" : "0"); };
  return [open, setOpen, setRaw, saved != null];
}

// Secção com resumo: fechada quando não há nada por fazer, abre sozinha quando há algo pendente ou se navega para dentro dela.
export function Fold({ title, sub, open: force, testid, children, className = "", defaultOpen, pending, memo }) {
  const mobile = useMobile();
  const [open, setOpen, setRaw, remembered] = useFoldState(memo, pending ?? defaultOpen ?? !mobile);
  useEffect(() => { if (force) { setRaw(true); } }, [force]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (pending != null && !remembered) { setRaw(pending); } }, [pending]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (defaultOpen === false && !force && pending == null) { setRaw(false); } }, [defaultOpen]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className={`bg-white rounded-[18px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 ${className}`} data-testid={testid}>
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} data-testid={`${testid}-toggle`}
        className="w-full flex items-center gap-3 px-[18px] md:px-6 py-4 text-left">
        <span className="flex-1 min-w-0">
          <span className="block font-heading text-xl md:text-2xl navy-text">{title}</span>
          {sub && <span className="block text-[15px] text-slate-500" data-testid={`${testid}-sub`}>{sub}</span>}
        </span>
        <ChevronDown size={20} className={`shrink-0 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="pb-2" data-testid={`${testid}-body`}>{children}</div>}
    </div>
  );
}
